import { Component } from '@angular/core';
import {
    FormBuilder,
    Validators,
    FormsModule,
    ReactiveFormsModule,
} from '@angular/forms';
import { MatInput } from '@angular/material/input';
import { MatIcon } from '@angular/material/icon';
import { MatFormField, MatLabel, MatError } from '@angular/material/form-field';
import { ToastrService } from 'ngx-toastr';
import { MatIconModule } from '@angular/material/icon';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';

@Component({
    selector: 'app-color-palette',
    standalone: true,
    imports: [
        FormsModule,
        ReactiveFormsModule,
        MatFormField,
        MatLabel,
        MatInput,
        MatError,
        MatIcon,
        MatIconModule,
        MatCheckboxModule,
        MatRadioModule,
        MatSelectModule,
        MatDatepickerModule,
        MatNativeDateModule,
    ],
    templateUrl: './color-palette.component.html',
    styleUrl: './color-palette.component.css',
})
export class ColorPaletteComponent {
    constructor(private toastr: ToastrService) {}

    ngOnInit() {
    }

    mostrarToastr(tipo: string): void {
        switch (tipo) {
            case 'success':
                this.toastr.success('Operación exitosa', 'Éxito');
                break;
            case 'error':
                this.toastr.error('Algo salió mal', 'Error');
                break;
            case 'warning':
                this.toastr.warning('Precaución', 'Advertencia');
                break;
            case 'info':
                this.toastr.info('Información relevante', 'Info');
                break;
        }
    }
}
